var map = {
	"./video-00-grundlagen/video.js": 41676,
	"./video-01-musik-dein-erster-beat/video.js": 46750,
	"./video-02-musik-die-band-party-on/video.js": 89506,
	"./video-03-musik-die-beat-station/video.js": 1756,
	"./video-04-musik-stopptanz-maschine/video.js": 10820,
	"./video-05-musik-blumen-memo-spiel/video.js": 67341,
	"./video-06-hallo-welt/video.js": 13272,
	"./video-07-weltraum-maus/video.js": 19156,
	"./video-08-maus-blinzelt/video.js": 18532,
	"./video-09-maus-tanzt/video.js": 29070,
	"./video-10-wimmelbild/video.js": 98348,
	"./video-11-kunst-mit-der-maus/video.js": 53250,
	"./video-12-zahlen-raten/video.js": 73527,
	"./video-13-mathefant/video.js": 81767,
	"./video-14-deine-story/video.js": 3519,
	"./video-15-kugelfisch/video.js": 4622
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 26817;